/**
 * El API compara allowlist `type: email` con el claim `email` del Bearer.
 * El access token de Cognito casi nunca lo trae; el id token sí
 * (`user_info` de localStorage se parsea de ese JWT).
 */

import { decodeJwtPayload } from './cognitoJwt';

function asToken(value) {
  const token = typeof value === 'string' ? value.trim() : '';
  return token || null;
}

function hasEmailClaim(payload) {
  return typeof payload?.email === 'string' && Boolean(payload.email.trim());
}

function isAccessToken(payload) {
  return payload?.token_use === 'access';
}

function isIdToken(payload) {
  if (!payload) return false;
  if (payload.token_use === 'id') return true;
  if (payload.token_use === 'access') return false;
  return hasEmailClaim(payload);
}

/**
 * Elige el JWT que hay que mandar al API (id token).
 * Si `cognito_tokens.idToken` quedó con el access (claves cruzadas),
 * toma el otro: si no, `getsharedwithmelists` no matchea filas solo-email.
 *
 * @param {{ idToken?: string, accessToken?: string, id_token?: string, access_token?: string }} [tokens]
 * @returns {string|null}
 */
export function pickCognitoIdToken(tokens = {}) {
  const labeled = [
    asToken(tokens.idToken || tokens.id_token),
    asToken(tokens.accessToken || tokens.access_token),
  ]
    .filter(Boolean)
    .map((token) => ({ token, payload: decodeJwtPayload(token) }))
    .filter((item) => item.payload);

  if (!labeled.length) return null;

  const withEmail = labeled.filter((item) => hasEmailClaim(item.payload));
  const idTokens = labeled.filter((item) => isIdToken(item.payload));

  const idWithEmail = withEmail.find((item) => !isAccessToken(item.payload));
  if (idWithEmail) return idWithEmail.token;
  if (withEmail[0]) return withEmail[0].token;
  if (idTokens[0]) return idTokens[0].token;

  const storedId = asToken(tokens.idToken || tokens.id_token);
  const storedIdItem = labeled.find((item) => item.token === storedId);
  if (storedIdItem && !isAccessToken(storedIdItem.payload)) return storedIdItem.token;

  return labeled[0].token;
}
